var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
import { IsBoolean, IsNumber, IsOptional, IsString, IsUUID } from 'class-validator';
import { UserFullSizeDto } from '../user/index.js';
export class JwtTokenDto {
    expiresIn;
    accessToken;
    user;
    redirectToCall;
    fromTan;
    fromExerciseUpload;
    diagnosisFormsCompleted;
}
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Number)
], JwtTokenDto.prototype, "expiresIn", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], JwtTokenDto.prototype, "accessToken", void 0);
__decorate([
    Expose(),
    Type(() => UserFullSizeDto),
    __metadata("design:type", UserFullSizeDto)
], JwtTokenDto.prototype, "user", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsUUID(),
    __metadata("design:type", String)
], JwtTokenDto.prototype, "redirectToCall", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], JwtTokenDto.prototype, "fromTan", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], JwtTokenDto.prototype, "fromExerciseUpload", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], JwtTokenDto.prototype, "diagnosisFormsCompleted", void 0);
//# sourceMappingURL=jwt-token.dto.js.map